import { routeItem } from '@/types';
import { lazy } from 'react';

const About = lazy(() => import('./pages'));

export const aboutRoutes: routeItem[] = [
  {
    path: 'about-us',
    // index: true,
    element: <About />,
  },
];